import React, { use, useEffect } from "react";
import Image from "next/image";
import Back_ground from "../../components/assets/ipillion/Back_ground";
import { useTranslations } from "next-intl";
import Logo from "../../components/assets/ipillion/Logo";
import Section_name from "./Section_name";
import IpillionLogo from "../../public/projects/IpillionLogo";
import { useRouter } from "next/router";
const Headr = () => {
  const t = useTranslations("ipillion.Header");
  const router = useRouter();
  const lang = router.locale;

  return (
    <>
      <div className="hidden mds:block">
        {/* <Back_ground className="w-full absolute" /> */}
        <svg
          className="absolute z-10 w-full h-auto flex justify-center "
          viewBox="0 0 1439 799"
          fill="#F9F9FA"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid meet"
        >
          <path
            d="M0 0H1439V498.5C269.138 498.5 0 798.5 0 798.5V0Z"
            fill="#F9F9FA"
          />
        </svg>
      </div>
      <div className="mds:hidden h-32 relative">
        <svg
          className="absolute z-10 w-full h-auto flex justify-center "
          width="430"
          height="838"
          viewBox="0 0 430 838"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0H430V747.707C80.4234 747.707 1.9827e-10 837.5 1.9827e-10 837.5L0 0Z"
            fill="#F9F9FA"
          />
        </svg>
      </div>
      <div className="grid grid-cols-12 z-20 relative   gap-1 lg:h-[750px] mt-[1%] md:mt-[7%] lg:mt-0 lg:pt-16 max-w-[90rem] mx-auto responsive">
        <div className="col-span-12 lg:col-span-6 flex flex-col justify-center">
          <div className=" lg:h-[75.09px] lg:w-[174px] h-[73px] w-[170px] relative mb-8 mt-5 lg:mt-0">
            <IpillionLogo />
          </div>
          <div className="mb-6 ">
            <h1 className="text-[#D60014] font-[700] leading-[56px] text-[32px] lg:text-[40px]">
              {t("title")}
            </h1>
            <hr className="h-[5px] w-[138px] rounded-[22.5px] bg-[#D60014]" />
          </div>
          <div className="max-w-[685px] min-w-[280px]">
            <p className="font-[400] text-[14px] relative  lg:text-[18px]  text-black leading-[20px] lg:leading-[26px]">
              {t("description")}
            </p>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-6">
          <div className="flex justify-center items-center h-full w-full">
            <div
              className={`${
                lang == "ar" ? "-scale-x-100" : null
              } relative w-[346px] h-[283px] lg:h-[469px] lg:w-[565px] mt-5`}
            >
              <Image src="/projects/head-bike.png" layout="fill" alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Headr;
